import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BackendPaths } from '@common/backend-paths';
import { DataService } from '@data/data.service';
import { TemplateEditorDialogComponent } from '../template-editor-dialog/template-editor-dialog.component';

@Component({
  selector: 'app-template-files-list',
  templateUrl: './template-files-list.component.html'
})
export class TemplateFilesListComponent implements OnInit {

  files: any[] = [
    {}, {}, {}, {}, {}
  ];

  constructor(
    private dataService: DataService,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.dataService.get(
      BackendPaths.TEMPLATES
    ).subscribe((res: any) => {
      const r = res?.result;
      if (Array.isArray(r?.files)) {
        this.files = r.files;
      }
    });
  }

  show(e: any) {
    this.matDialog.open(
      TemplateEditorDialogComponent,
      {
        data: {
          file: e
        }
      }
    );
  }
}
